import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Facebook as LoadingState } from 'react-content-loader';
import * as yup from 'yup';
import TwitterText from 'twitter-text';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers';
import {
  ICampaigns,
  IOriginalContent
} from 'redux/slices/Campaigns/Campaigns.interface';
import {
  selectGroupAmbassador,
  setData,
  setLoadingGroupAmbassador
} from 'redux/slices/GroupAmbassador/GroupAmbassadorSlice';
import { selectUser } from 'redux/slices/userSlice';
import {
  Igroup,
  IGroupAmssador
} from 'redux/slices/GroupAmbassador/GroupAmbassador.interface';
import { getSuggestedPostDetail } from 'services/rest/SuggestedPost/getSuggestedPostDetail';
import { approveSuggestedPost } from 'services/rest/SuggestedPost/approveSuggestedPost';
import { completeSuggestedPost } from 'services/rest/SuggestedPost/completeSuggestedPost';
import {
  createCampaign,
  CampaignData
} from 'services/rest/Campaign/createCampaign';
import { getGroupAmbassador } from 'services/rest/GetGroupAmbassador/GetGroupAmbassador';
import { RequiredString } from 'helpers/yupHelper';
import {
  awsUploadFileHelper,
  setFileNameHelper,
  setFilePdfHelper
} from 'helpers/awsCampaignFileHelper';
import { awsUploadVideoHelper } from 'helpers/awsVideoHelper';
import { sortGroups } from 'helpers/groupsHelper';
import { getUrlS3 } from 'constants/setup.constants';
import { generateRandAlphaNumStr } from 'Utils/StringRandom';
import { facebookURLs } from 'Utils/FacebookURLs';
import { SuccessAlert, ErrorAlert } from 'components/Alert';
import EditSuggestedPostForm from './SuggestedPostDetailForm';
import posthog from 'posthog-js';

interface CampaignParams {
  id: string;
}

const EditCampaignNewPage: React.FC = () => {
  const { t } = useTranslation(['campaigns_page', 'validations']);
  const dispatch = useDispatch();
  const { id } = useParams<CampaignParams>();

  const [campaign, setCampaign] = useState<ICampaigns>();
  const [loadingCampaigns, setLoadingCampaigns] = useState(true);
  const [suggestedPostPoints, setSuggestedPostPoints] = useState<number>(10);

  const userSchema = yup.object().shape({
    name: RequiredString().max(
      150,
      t('validations:length_error', { max: 150 })
    ),
    description: RequiredString().max(
      1800,
      t('validations:length_error', { max: 1800 })
    )
  });

  const { register, control, handleSubmit, errors } = useForm({
    resolver: yupResolver(userSchema)
  });

  useEffect(() => {
    dispatch(setLoadingGroupAmbassador(true));
    getData();
  }, []);
  const [backendError, setBackendError] = useState<string | null>(null);
  const [startDate, setStartDate] = useState(new Date());
  const [finishDate, setFinishDate] = useState(new Date());
  const [hourt, setHourt] = useState<any>('00');
  const [minutes, setMinutes] = useState<any>('00');
  const history = useHistory();
  const [image, setImage] = useState<Array<any>>([]);
  const [imageTwitter, setImageTwitter] = useState<Array<any>>([]);
  const [imageLinkedin, setImageLinkedin] = useState<Array<any>>([]);
  const [imageInstagram, setImageInstagram] = useState<Array<any>>([]);
  const [imageWhatsapp, setImageWhatsapp] = useState<Array<any>>([]);
  const [imageTiktok, setImageTiktok] = useState<Array<any>>([]);
  const [fileErrorInstagram, setFileErrorInstagram] = useState<string>('');
  const [errorSocialNetwork, setErrorSocialNetwork] = useState<string>('');
  const [fileErrorTwitter, setFileErrorTwitter] = useState<string>('');
  const [fileErrorLinkedin, setFileErrorLinkedin] = useState<string>('');
  const [fileErrorWhatsapp, setFileErrorWhatsapp] = useState<string>('');
  const [fileErrorTiktok, setFileErrorTiktok] = useState<string>('');
  const [group, setGroup] = useState<Array<number>>([]);
  const [ambassadors, setAmbassadors] = useState<Array<number>>([]);
  const [backendSuccess, setBackendSuccess] = useState<string | null>(null);

  const [type, setType] = useState({
    instagram: 'text',
    twitter: 'text',
    linkedin: 'text',
    tiktok: 'text',
    whatsapp: 'text'
  });

  const [loader, setLoader] = useState(false);

  const [editImage, setEditImage] = useState({
    photo: false,
    twitter: false,
    linkedin: false,
    instagram: false,
    tiktok: false,
    whatsapp: false
  });

  const { currentUser } = useSelector(selectUser);
  const { groupsAmbassador = [] } = useSelector(selectGroupAmbassador);

  const contentLimits = {
    twitter: 280,
    linkedin: 1500,
    instagram: 700,
    tiktok: 150,
    whatsapp: 280
  };

  const [invalidLimit, setInvalidLimit] = useState({
    twitter: false,
    linkedin: false,
    instagram: false,
    tiktok: false,
    whatsapp: false
  });

  const getFirstImageFromSocialNetworks = (
    contentPerSocialNetwork: any
  ): string | null => {
    for (const network of ['instagram', 'linkedin', 'twitter', 'whatsapp']) {
      const content = contentPerSocialNetwork?.[network];
      if (content?.type === 'image' && content?.picturesUrls?.length > 0) {
        return content.picturesUrls[0];
      }
    }
    return null;
  };

  const no_characters = /^(?!.*[!@#$%^&*()\-_+={}[\]|\\;:'"ª|!· º\\,<.>/?]{5}).+/;
  const no_mentions = /^(?!.*(?:\B@|https?:\/\/|www\.|\b[\w-]+\.(?:com|net|org|io|co|me|tv|app|ly|gg)\b))[\s\S]+$/i;

  const [uploadedTwitter, setUploadedTwitter] = useState<boolean | null>(null);
  const [uploadedLinkedin, setUploadedLinkedin] = useState<boolean | null>(
    null
  );
  const [uploadedInstagram, setUploadedInstagram] = useState<boolean | null>(
    null
  );
  const [uploadedTiktok, setUploadedTiktok] = useState<boolean | null>(null);
  const [uploadedWhatsapp, setUploadedWhatsapp] = useState<boolean | null>(
    null
  );
  const [linkedinUrn, setLinkedinUrn] = useState('');
  const [linkedinUrnError, setLinkedinUrnError] = useState('');

  const [socialContent, setSocialContent] = useState<{
    twitter: {
      [key: string]: string;
    };
    linkedin: {
      [key: string]: string;
    };
    tiktok: {
      [key: string]: string;
    };
  }>({
    twitter: {
      content: ''
    },
    linkedin: {
      content: ''
    },
    tiktok: {
      content: ''
    }
  });

  const loadMultipleContents = () => {
    const multipleContents = ['linkedin', 'twitter', 'tiktok'];
    for (const social of multipleContents) {
      if (
        campaign?.contentPerSocialNetwork[
          social as keyof ICampaigns['contentPerSocialNetwork']
        ]
      ) {
        Object.keys(
          campaign?.contentPerSocialNetwork[
            social as keyof ICampaigns['contentPerSocialNetwork']
          ]
        )
          .filter(key => {
            return key.includes('content');
          })
          .forEach((key: string) => {
            if (['content', 'content2', 'content3'].includes(key)) {
              const value = campaign?.contentPerSocialNetwork?.[
                social as keyof ICampaigns['contentPerSocialNetwork']
              ][key as keyof IOriginalContent] as string;

              setSocialContent(prev => ({
                ...prev,
                [social]: {
                  ...prev[social as 'linkedin' | 'twitter' | 'tiktok'],
                  [key]: value
                }
              }));
            }
          });
      }
    }
  };

  const getData = async () => {
    await getSuggestedPostDetail(id, currentUser?.token)
      .then(result => {
        setCampaign(result.data.data);
        setSuggestedPostPoints(result.data.data.points || 10);
        setLoadingCampaigns(false);
      })
      .catch(error => {
        setLoadingCampaigns(false);
      });
  };
  useEffect(() => {
    if (campaign) {
      setHourt(new Date(campaign.startDateUTC).getHours());
      setMinutes(new Date(campaign.startDateUTC).getMinutes());
      setType({
        twitter: campaign?.contentPerSocialNetwork?.twitter?.type
          ? campaign?.contentPerSocialNetwork?.twitter?.type
          : 'text',
        linkedin: campaign?.contentPerSocialNetwork?.linkedin?.type
          ? campaign?.contentPerSocialNetwork?.linkedin?.type
          : 'text',
        instagram: campaign?.contentPerSocialNetwork?.instagram?.type
          ? campaign?.contentPerSocialNetwork?.instagram?.type
          : 'text',
        tiktok: campaign?.contentPerSocialNetwork?.tiktok?.type
          ? campaign?.contentPerSocialNetwork?.tiktok?.type
          : 'text',
        whatsapp: campaign?.contentPerSocialNetwork?.whatsapp?.type
          ? campaign?.contentPerSocialNetwork?.whatsapp?.type
          : 'text'
      });
      setGroup(campaign?.groupsIds ? campaign.groupsIds : []);
      setAmbassadors(campaign?.ambassadorsIds ? campaign.ambassadorsIds : []);
      const photo =
        campaign?.photo ||
        getFirstImageFromSocialNetworks(campaign?.contentPerSocialNetwork);
      setImage(photo ? [photo] : []);
      loadMultipleContents();
    }
  }, [campaign]);

  if (loadingCampaigns) {
    return <LoadingState height="230px" width="100%" />;
  }

  const onSelectedSocialNetwork = (
    socialNetwork: string,
    file: any,
    isEdit: boolean
  ) => {
    const socialNetworkSelected = editImage as any;
    const socialNetworks = {
      ...socialNetworkSelected,
      [socialNetwork]: isEdit
    };
    setEditImage(socialNetworks);
  };

  const handleClick = (
    startDate: Date,
    finishDate: Date,
    hour: any,
    minutes: any
  ) => {
    const dateStartString = `${startDate.getFullYear()}/${
      startDate.getMonth() + 1
    }/${startDate.getDate()} ${hour}:${minutes}:00`;

    const dateStart = new Date(dateStartString);

    const dateFinishString = `${finishDate.getFullYear()}/${
      finishDate.getMonth() + 1
    }/${finishDate.getDate()} 22:59:59`;

    const dateFinish = new Date(dateFinishString);

    setStartDate(dateStart);
    setFinishDate(dateFinish);
  };

  const handleImagen = (select: any, content: string) => {
    // Normalize to array - handles both single object from UploadFileVideo and arrays from other sources
    const normalizedSelect = Array.isArray(select)
      ? select
      : select
      ? [select]
      : [];
    switch (content) {
      case 'photo':
        setImage(normalizedSelect);
        onSelectedSocialNetwork('photo', normalizedSelect, true);
        break;
      case 'twitter':
        setImageTwitter(normalizedSelect);
        onSelectedSocialNetwork('twitter', normalizedSelect, true);
        break;
      case 'linkedin':
        setImageLinkedin(normalizedSelect);
        onSelectedSocialNetwork('linkedin', normalizedSelect, true);
        break;
      case 'instagram':
        setImageInstagram(normalizedSelect);
        onSelectedSocialNetwork('instagram', normalizedSelect, true);
        break;
      case 'tiktok':
        setImageTiktok(normalizedSelect);
        onSelectedSocialNetwork('tiktok', normalizedSelect, true);
        break;
      case 'whatsapp':
        setImageWhatsapp(normalizedSelect);
        onSelectedSocialNetwork('whatsapp', normalizedSelect, true);
        break;
    }
  };

  const handleParticipation = (
    group: Array<Igroup>,
    ambassadors: Array<Igroup>
  ) => {
    const groupsIds = group.map(select => select.id);
    const ambassadorsIds = ambassadors.map(select => select.id);

    setGroup(groupsIds);
    setAmbassadors(ambassadorsIds);
  };

  const handleTypeFile = (body: any) => {
    setType(body);
  };

  const getGroup = async (name: string) => {
    await getGroupAmbassador(currentUser?.token, 1, 500, name)
      .then(response => {
        const group = sortGroups(response.data.data.groups.docs);
        const ambassadors = sortGroups(response.data.data.ambassadors.docs);
        const groupAmbassador: IGroupAmssador = {
          groups: group,
          ambassador: ambassadors
        };
        dispatch(setData(groupAmbassador));
        dispatch(setLoadingGroupAmbassador(false));
      })
      .catch(error => {
        dispatch(setLoadingGroupAmbassador(false));
      });
  };

  const regextValidationTwitter = (content: string) => {
    const regex = new RegExp(no_characters);
    return regex.test(content);
  };

  const regextValidationTiktok = (content: string) => {
    const regex = new RegExp(no_mentions);
    return regex.test(content);
  };

  const onSubmit = async (campaignData: CampaignData) => {
    setLoader(true);

    if (image.length === 0) {
      setBackendError(t('campaigns_page:image_required'));
      setLoader(false);
      return;
    }

    if (ambassadors.length == 0 && group.length == 0) {
      setBackendError(t('error_info_ambassador'));
      setLoader(false);
      return;
    }

    const pointsValue: any = {
      facebook: { ...campaignData?.facebook },
      twitter: { ...campaignData?.twitter },
      linkedin: { ...campaignData?.linkedin },
      instagram: { ...campaignData?.instagram },
      tiktok: { ...campaignData?.tiktok },
      whatsapp: { ...campaignData?.whatsapp }
    };
    for (const network in pointsValue) {
      const isEmptyPoint = Object.values(pointsValue[network]).some(
        point => point === null || point === ''
      );
      if (isEmptyPoint) {
        setBackendError(t('error_sn_points'));
        setLoader(false);
        return;
      }
    }

    if (
      campaignData.includesFacebook &&
      !facebookURLs(campaignData.linkFacebook)
    ) {
      setBackendError(t('error_url'));
      setLoader(false);
      return;
    }

    if (campaignData.includesTwitter) {
      for (const key of Object.keys(socialContent.twitter)) {
        const validationContent = regextValidationTwitter(
          socialContent.twitter[key]
        );
        const contentTwitterLength = socialContent.twitter[key]
          ? TwitterText.getTweetLength(socialContent.twitter[key])
          : 0;
        if (!socialContent.twitter[key]) {
          setBackendError(t('error_text_twitter'));
          setLoader(false);
          return;
        } else if (!validationContent) {
          setBackendError(t('characters'));
          setLoader(false);
          return;
        } else if (contentTwitterLength > contentLimits.twitter) {
          setBackendError(t('error_limit'));
          setInvalidLimit({
            ...invalidLimit,
            twitter: true
          });
          setLoader(false);
          return;
        }
      }
      campaignData.twitterContents = socialContent.twitter;
    }

    if (
      type.twitter !== 'text' &&
      campaignData.includesTwitter &&
      imageTwitter.length === 0
    ) {
      setBackendError(t('error_info_twitter'));
      setFileErrorTwitter(t('error_info_tw_text'));
      setLoader(false);
      return;
    }

    if (campaignData.includesLinkedin) {
      for (const key of Object.keys(socialContent.linkedin)) {
        const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
        const countPattern = (
          (socialContent.linkedin[key] || '').match(urlPattern) || []
        ).length;
        const contentLinkedinLength = socialContent.linkedin[key]
          ? socialContent.linkedin[key]
              .replace(/(?:https?|ftp):\/\/\S+/g, ' ')
              .trim().length + countPattern
          : 0;
        if (
          (type.linkedin === 'text' || type.linkedin === 'share') &&
          !socialContent.linkedin[key]
        ) {
          setBackendError(t('error_text_linkedin'));
          setLoader(false);
          return;
        } else if (contentLinkedinLength > contentLimits.linkedin) {
          setBackendError(t('error_limit'));
          setInvalidLimit({
            ...invalidLimit,
            linkedin: true
          });
          setLoader(false);
          return;
        }
      }
      if (type.linkedin != 'share') {
        campaignData.linkedinContents = socialContent.linkedin;
      } else {
        if (type.linkedin === 'share' && !campaignData.contentLinkedinShare) {
          setBackendError(t('error_text_linkedin'));
          setLoader(false);
          return;
        } else if (type.linkedin === 'share' && !linkedinUrn) {
          setLinkedinUrnError(t('error_urn_linkedin'));
          setLoader(false);
          return;
        }
        campaignData.linkedinContents = campaignData.contentLinkedinShare;
      }
    }

    if (
      type.linkedin !== 'text' &&
      type.linkedin !== 'share' &&
      campaignData.includesLinkedin &&
      imageLinkedin.length === 0
    ) {
      setBackendError(t('error_info_linkedin'));
      setFileErrorLinkedin(t('error_info_file_ln'));
      setLoader(false);
      return;
    }

    if (campaignData.includesInstagram) {
      const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
      const countPattern = (
        (campaignData.contentInstagram || '').match(urlPattern) || []
      ).length;
      const contentInstagramLength = campaignData.contentInstagram
        ? campaignData.contentInstagram
            .replace(/(?:https?|ftp):\/\/\S+/g, ' ')
            .trim().length + countPattern
        : 0;
      if (imageInstagram.length == 0) {
        setBackendError(t('error_info_instagram'));
        setFileErrorInstagram(t('error_info_instagram'));
        setLoader(false);
        return;
      } else if (contentInstagramLength > contentLimits.instagram) {
        setBackendError(t('error_limit'));
        setInvalidLimit({
          ...invalidLimit,
          instagram: true
        });
        setLoader(false);
        return;
      }
    }

    if (campaignData.includesWhatsapp) {
      const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
      const countPattern = (
        (campaignData.contentWhatsapp || '').match(urlPattern) || []
      ).length;
      const contentWhatsappLength = campaignData.contentWhatsapp
        ? campaignData.contentWhatsapp
            .replace(/(?:https?|ftp):\/\/\S+/g, ' ')
            .trim().length + countPattern
        : 0;
      if (imageWhatsapp.length === 0) {
        setBackendError(t('error_info_whatsapp'));
        setFileErrorWhatsapp(t('error_info_wa_text'));
        setLoader(false);
        return;
      } else if (contentWhatsappLength > contentLimits.whatsapp) {
        setBackendError(t('error_limit'));
        setInvalidLimit({
          ...invalidLimit,
          whatsapp: true
        });
        setLoader(false);
        return;
      }
    }

    if (campaignData.includesTiktok) {
      for (const key of Object.keys(socialContent.tiktok)) {
        const validationContent = regextValidationTiktok(
          socialContent.tiktok[key]
        );
        const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
        const countPattern = (
          (socialContent.tiktok[key] || '').match(urlPattern) || []
        ).length;
        const contentTiktokLength = socialContent.tiktok[key]
          ? socialContent.tiktok[key]
              .replace(/(?:https?|ftp):\/\/\S+/g, ' ')
              .trim().length + countPattern
          : 0;
        if (!socialContent.tiktok[key]) {
          setBackendError(t('error_text_tiktok'));
          setLoader(false);
          return;
        } else if (!validationContent) {
          setBackendError(t('pattern_tiktok'));
          setLoader(false);
          return;
        } else if (imageTiktok.length == 0) {
          setBackendError(t('error_info_tiktok'));
          setFileErrorTiktok(t('error_info_tiktok'));
          setLoader(false);
          return;
        } else if (contentTiktokLength > contentLimits.tiktok) {
          setBackendError(t('error_limit'));
          setInvalidLimit({
            ...invalidLimit,
            tiktok: true
          });
          setLoader(false);
          return;
        }
      }
      campaignData.tiktokContents = socialContent.tiktok;
    }

    if (
      type.tiktok === 'video' &&
      campaignData.includesTiktok &&
      imageTiktok.length === 0
    ) {
      setBackendError(t('error_info_tiktok'));
      setLoader(false);
      return;
    }

    campaignData.startDate = new Date(
      `${startDate.getFullYear()}/${
        startDate.getMonth() + 1
      }/${startDate.getDate()} ${hourt}:${minutes}`
    ).toString();
    campaignData.finishDate = new Date(
      `${finishDate.getFullYear()}/${
        finishDate.getMonth() + 1
      }/${finishDate.getDate()} 22:59:59`
    ).toString();
    campaignData.companyId = currentUser.user.companyId;
    campaignData.ambassadorsIds = ambassadors;
    campaignData.groupsIds = group;

    const photoValue = Array.isArray(image) ? image[0] : image;
    const isNewPhotoBuffer = photoValue && typeof photoValue !== 'string';

    if (editImage.photo && isNewPhotoBuffer) {
      const namePhoto = generateRandAlphaNumStr();
      const uploadedPhoto = await awsUploadFileHelper(
        currentUser?.token,
        photoValue,
        true,
        'CAMPAIGN',
        namePhoto,
        t,
        setBackendError
      );
      if (uploadedPhoto) {
        campaignData.photo = getUrlS3('campaigns', namePhoto);
      } else {
        setBackendError(t('validations:file_error'));
        setLoader(false);
        return;
      }
    } else if (typeof photoValue === 'string' && photoValue) {
      campaignData.photo = photoValue;
    }

    let facebook: any;

    let twitter: any;
    if (editImage.twitter) {
      if (type.twitter === 'image') {
        const twitterFile = [];
        if (imageTwitter) {
          setUploadedTwitter(false);
        }
        for (const file of imageTwitter) {
          if (!file?.file?.type) {
            const name = file.url.split('/').reverse()[0];
            twitterFile.push({ name });
            continue;
          }
          const nameTwitter = setFileNameHelper(file, false);
          await awsUploadFileHelper(
            currentUser?.token,
            file,
            false,
            'CAMPAIGN',
            nameTwitter,
            t,
            setBackendError
          );
          twitterFile.push({ name: nameTwitter });
        }
        twitter = {
          type: type['twitter'],
          url: twitterFile.map((file: any) => getUrlS3('campaigns', file?.name))
        };
      }
      if (type.twitter === 'video') {
        setUploadedTwitter(false);
        const twitterFileArg = Array.isArray(imageTwitter)
          ? imageTwitter[0]
          : imageTwitter;
        const nameTwitter = setFileNameHelper(twitterFileArg, false);
        const uploadedTwitter = await awsUploadVideoHelper(
          currentUser?.token,
          twitterFileArg,
          'CAMPAIGN',
          nameTwitter,
          t,
          setBackendError
        );
        if (uploadedTwitter) {
          twitter = {
            type: type['twitter'],
            url: getUrlS3('campaigns', nameTwitter)
          };
          setUploadedTwitter(true);
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
    } else {
      if (campaign?.contentPerSocialNetwork?.twitter?.type === 'image') {
        twitter = campaign?.contentPerSocialNetwork?.twitter?.picturesUrls;
      } else {
        twitter = campaign?.contentPerSocialNetwork?.twitter?.videoUrl;
      }

      twitter = {
        type: type['twitter'],
        url: twitter
      };
    }

    let linkedin: any;
    if (editImage.linkedin) {
      if (type.linkedin === 'image') {
        const linkedinFile = [];
        if (imageLinkedin) {
          setUploadedLinkedin(false);
        }
        for (const file of imageLinkedin) {
          if (!file?.file?.type) {
            const name = file.url.split('/').reverse()[0];
            linkedinFile.push({ name });
            continue;
          }
          const nameLinkedin = setFileNameHelper(file, false);
          await awsUploadFileHelper(
            currentUser?.token,
            file,
            false,
            'CAMPAIGN',
            nameLinkedin,
            t,
            setBackendError
          );
          linkedinFile.push({ name: nameLinkedin });
        }
        linkedin = {
          type: type['linkedin'],
          url: linkedinFile.map((file: any) =>
            getUrlS3('campaigns', file?.name)
          )
        };
      }
      if (type.linkedin === 'video') {
        setUploadedLinkedin(false);
        const linkedinFileArg = Array.isArray(imageLinkedin)
          ? imageLinkedin[0]
          : imageLinkedin;
        const nameLinkedin = setFileNameHelper(linkedinFileArg, false);
        const uploadedLinkedin = await awsUploadVideoHelper(
          currentUser?.token,
          linkedinFileArg,
          'CAMPAIGN',
          nameLinkedin,
          t,
          setBackendError
        );
        if (uploadedLinkedin) {
          linkedin = {
            type: type['linkedin'],
            url: getUrlS3('campaigns', nameLinkedin)
          };
          setUploadedLinkedin(true);
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
      if (type.linkedin === 'pdf') {
        const nameLinkedin = setFilePdfHelper(imageLinkedin[0].name);
        const uploadedLinkedin = await awsUploadFileHelper(
          currentUser?.token,
          imageLinkedin[0],
          false,
          'CAMPAIGN',
          `${currentUser.user.companyId}/${nameLinkedin}`,
          t,
          setBackendError
        );
        if (uploadedLinkedin) {
          linkedin = {
            type: type['linkedin'],
            url: getUrlS3(
              `campaigns/${currentUser.user.companyId}`,
              nameLinkedin
            )
          };
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
    } else {
      if (campaign?.contentPerSocialNetwork?.linkedin?.type === 'image') {
        linkedin = campaign?.contentPerSocialNetwork?.linkedin?.picturesUrls;
      } else if (
        campaign?.contentPerSocialNetwork?.linkedin?.type === 'video'
      ) {
        linkedin = campaign?.contentPerSocialNetwork?.linkedin?.videoUrl;
      } else {
        linkedin = campaign?.contentPerSocialNetwork?.linkedin?.pdfUrl;
      }

      linkedin = {
        type: type['linkedin'],
        url: linkedin
      };
    }
    if (type.linkedin === 'share') {
      if (linkedinUrn) {
        linkedin = {
          type: type['linkedin'],
          url: linkedinUrn,
          contentParticipation: socialContent.linkedin.content
        };
      } else {
        setLinkedinUrnError(t('error_urn_linkedin'));
        setLoader(false);
        return;
      }
    }

    let instagram: any;
    if (campaignData.includesInstagram) {
      if (editImage.instagram) {
        if (type.instagram === 'image') {
          const nameInstagram = setFileNameHelper(imageInstagram[0], false);
          const uploadedInstagramPhoto = await awsUploadFileHelper(
            currentUser?.token,
            imageInstagram[0],
            false,
            'CAMPAIGN',
            nameInstagram,
            t,
            setBackendError
          );
          if (uploadedInstagramPhoto) {
            instagram = {
              type: type['instagram'],
              url: [getUrlS3('campaigns', nameInstagram)]
            };
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
        if (type.instagram === 'video') {
          setUploadedInstagram(false);
          const instagramFileArg = Array.isArray(imageInstagram)
            ? imageInstagram[0]
            : imageInstagram;
          const nameInstagram = setFileNameHelper(instagramFileArg, false);
          const uploadedInstagram = await awsUploadVideoHelper(
            currentUser?.token,
            instagramFileArg,
            'CAMPAIGN',
            nameInstagram,
            t,
            setBackendError
          );
          if (uploadedInstagram) {
            instagram = {
              type: type['instagram'],
              url: getUrlS3('campaigns', nameInstagram)
            };
            setUploadedInstagram(true);
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
      } else {
        if (campaign?.contentPerSocialNetwork?.instagram?.type === 'image') {
          instagram =
            campaign?.contentPerSocialNetwork?.instagram?.picturesUrls;
        } else {
          instagram = campaign?.contentPerSocialNetwork?.instagram?.videoUrl;
        }

        instagram = {
          type: campaign?.contentPerSocialNetwork?.instagram?.type,
          url: instagram
        };
      }
    }

    let whatsapp: any;
    if (campaignData.includesWhatsapp) {
      if (editImage.whatsapp) {
        if (type.whatsapp === 'image') {
          const nameWhatsapp = setFileNameHelper(imageWhatsapp[0], false);
          const uploadedWhatsappPhoto = await awsUploadFileHelper(
            currentUser?.token,
            imageWhatsapp[0],
            false,
            'CAMPAIGN',
            nameWhatsapp,
            t,
            setBackendError
          );
          if (uploadedWhatsappPhoto) {
            whatsapp = {
              type: type['whatsapp'],
              url: [getUrlS3('campaigns', nameWhatsapp)]
            };
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
        if (type.whatsapp === 'video') {
          setUploadedWhatsapp(false);
          const whatsappFileArg = Array.isArray(imageWhatsapp)
            ? imageWhatsapp[0]
            : imageWhatsapp;
          const nameWhatsapp = setFileNameHelper(whatsappFileArg, false);
          const uploadedWhatsapp = await awsUploadVideoHelper(
            currentUser?.token,
            whatsappFileArg,
            'CAMPAIGN',
            nameWhatsapp,
            t,
            setBackendError
          );
          if (uploadedWhatsapp) {
            whatsapp = {
              type: type['whatsapp'],
              url: getUrlS3('campaigns', nameWhatsapp)
            };
            setUploadedWhatsapp(true);
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
      } else {
        if (campaign?.contentPerSocialNetwork?.whatsapp?.type === 'image') {
          whatsapp = campaign?.contentPerSocialNetwork?.whatsapp?.picturesUrls;
        } else {
          whatsapp = campaign?.contentPerSocialNetwork?.whatsapp?.videoUrl;
        }

        whatsapp = {
          type: campaign?.contentPerSocialNetwork?.whatsapp?.type,
          url: whatsapp
        };
      }
    }

    let tiktok: any;
    if (editImage.tiktok) {
      if (type.tiktok === 'video') {
        setUploadedTiktok(false);
        const tiktokFileArg = Array.isArray(imageTiktok)
          ? imageTiktok[0]
          : imageTiktok;
        const nameTiktok = setFileNameHelper(tiktokFileArg, false);
        const uploadedTiktok = await awsUploadVideoHelper(
          currentUser?.token,
          tiktokFileArg,
          'CAMPAIGN',
          nameTiktok,
          t,
          setBackendError
        );
        if (uploadedTiktok) {
          tiktok = {
            type: type['tiktok'],
            url: getUrlS3('campaigns', nameTiktok)
          };
          setUploadedTiktok(true);
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
    } else {
      tiktok = campaign?.contentPerSocialNetwork?.tiktok?.videoUrl;
      tiktok = {
        type: type['tiktok'],
        url: tiktok
      };
    }

    if (
      !campaignData.includesFacebook &&
      !campaignData.includesTwitter &&
      !campaignData.includesLinkedin &&
      !campaignData.includesInstagram &&
      !campaignData.includesWhatsapp &&
      !campaignData.includesTiktok
    ) {
      setErrorSocialNetwork(t('error_social_network'));
      setBackendError(t('error_social_network'));
      setLoader(false);
      return;
    }

    const { data, errors } = await createCampaign(
      currentUser?.token,
      campaignData,
      facebook,
      twitter,
      linkedin,
      instagram,
      tiktok,
      whatsapp
    );

    if (data) {
      posthog.capture('Creación de Campaña desde Propuesta de Campaña', {
        proposalId: id,
        campaignId: data?.id || data?.data?.id
      });
      // If post was pending, first approve it, then complete. If already approved, just complete.
      if (campaign?.status === 'pending') {
        await approveSuggestedPost(currentUser?.token, id, suggestedPostPoints);
      }
      await completeSuggestedPost(currentUser?.token, id, suggestedPostPoints);
      history.push('/admin/campaigns', t('success_message'));
    }
    if (errors) {
      setBackendError(errors.data);
      setLoader(false);
    }
    setLoader(false);
  };

  return (
    <>
      {backendSuccess && (
        <SuccessAlert
          text={backendSuccess}
          allowClose={true}
          onClose={() => setBackendSuccess(null)}
        />
      )}

      {backendError && (
        <ErrorAlert
          text={backendError}
          allowClose={true}
          onClose={() => setBackendError(null)}
        />
      )}

      <EditSuggestedPostForm
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        errors={errors}
        handleClick={handleClick}
        groupsAmbassador={groupsAmbassador}
        getData={getGroup}
        handleParticipation={handleParticipation}
        handleImage={handleImagen}
        campaign={campaign}
        handleTypeFile={handleTypeFile}
        control={control}
        type={type}
        setImageTwitter={setImageTwitter}
        setImageLinkedin={setImageLinkedin}
        setImageInstagram={setImageInstagram}
        setImageWhatsapp={setImageWhatsapp}
        setImageTiktok={setImageTiktok}
        loader={loader}
        setHourt={setHourt}
        setMinutes={setMinutes}
        sHour={hourt}
        sMinutes={minutes}
        errorSocialNetwork={errorSocialNetwork}
        fileErrorInstagram={fileErrorInstagram}
        fileErrorTwitter={fileErrorTwitter}
        fileErrorLinkedin={fileErrorLinkedin}
        fileErrorWhatsapp={fileErrorWhatsapp}
        fileErrorTiktok={fileErrorTiktok}
        contentLimits={contentLimits}
        invalidLimit={invalidLimit}
        uploadedTwitter={uploadedTwitter}
        uploadedLinkedin={uploadedLinkedin}
        uploadedInstagram={uploadedInstagram}
        uploadedWhatsapp={uploadedWhatsapp}
        uploadedTiktok={uploadedTiktok}
        socialContent={socialContent}
        setSocialContent={setSocialContent}
        linkedinUrn={linkedinUrn}
        setLinkedinUrn={setLinkedinUrn}
        linkedinUrnError={linkedinUrnError}
        setLinkedinUrnError={setLinkedinUrnError}
        onCampaignCreate={setSuggestedPostPoints}
        campaignPhoto={image}
      />
    </>
  );
};

export default EditCampaignNewPage;
